import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Structure, Typography} from 'components';
import {TransferAIS, TransferS2E} from './components';
import {makeStyles} from '@material-ui/styles';
import {sendTag} from "store/Tags";
import {useUser} from "hooks";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        padding: theme.spacing(3, 0, 2)
    }
}));

function TransferForms() {
    const classes = useStyles();
    const {scope} = useParams();
    const {user} = useUser();

    useEffect(() => {
        sendTag(user, `transfert_epargne::${scope === 'ais' ? "er":"es" }`);
        // eslint-disable-next-line
    }, []);

    return (
        <Structure.Folio
            title={
                <Typography
                    variant="h1"
                    color="blue"
                >
                    Transférer mon épargne
                </Typography>
            }
            className={classes.root}
            image="bg-transfer"
            position="center top -20px"
        >
            {scope === 'ais' && <TransferAIS />}
            {scope === 's2e' && <TransferS2E />}
        </Structure.Folio>
    );
}

export default TransferForms;
